import {
  useSetting,
  useAssignSetting,
} from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { NEXTJS_SIGNUP_SPLIT_250311 } from "@faire/web-api--source/indigofair/settings/NEXTJS_SIGNUP_SPLIT_250311";
import { useEffect } from "react";

export const useSettingAndAssignSignUpSplit = (): boolean => {
  const assignSettingSignUpSplit = useAssignSetting(NEXTJS_SIGNUP_SPLIT_250311);
  useEffect(() => {
    assignSettingSignUpSplit();
  }, [assignSettingSignUpSplit]);
  return useSetting(NEXTJS_SIGNUP_SPLIT_250311, false);
};

export const useAssignSettingSignUpSplit = () =>
  useAssignSetting(NEXTJS_SIGNUP_SPLIT_250311);

export const useSettingSignUpSplit = (): boolean => {
  return useSetting(NEXTJS_SIGNUP_SPLIT_250311, false);
};
